import api from './api';

export const passwordService = {
  async getAll() {
    const response = await api.get('/senhas');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/senhas/${id}`);
    return response.data;
  },

  async create(passwordData) {
    const response = await api.post('/senhas', passwordData);
    return response.data;
  },

  async update(id, passwordData) {
    const response = await api.put(`/senhas/${id}`, passwordData);
    return response.data;
  },

  async delete(id) {
    await api.delete(`/senhas/${id}`);
  },
};